module.exports = __webpack_public_path__ + "img/add.675fd654.svg";